<template>
  <div class="wrap">
    <div class="prove-header">
      <h1 class="common-header">
        <span @click="open(false, true)" class="prove-title">
          {{ $t('1055') }}
        </span>
        <span v-if="!status">
          <i class="el-icon-arrow-right"></i>
          {{ sonTitle }}
        </span>
      </h1>
      <template v-if="!isViewTemplateSetting">
        <!-- 模版配置 -->
        <el-button type="primary" @click="handleOpenTemplateSetting">{{ $t('1861') }}</el-button>
      </template>
    </div>
    <!-- 内容 -->
    <div class="by-content">
      <template v-if="!isViewTemplateSetting">
        <p class="margin-bottom">{{ $t('1811') }}</p>
        <ul class="active-list" v-if="status">
          <li v-for="item in proveDatas" :key="item[1].key" @click="open(item[1].state, false)">
            <p>
              <svg-icon icon-class="download-c" />
              {{ $t(item[1].key) }}
            </p>
          </li>
        </ul>
        <!-- 下载 -->
        <download v-if="!status && [1, 2, 3, 4, 6, 8].includes(type)" :type="type" />
        <downloadTawi v-if="!status && [5].includes(type)" ></downloadTawi>
        <!-- 员工证明 -->
        <on-job v-if="!status && type === 7" />
      </template>
      <template-download v-else @close="handlerCloseTem" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import download from './components/download'
import downloadTawi from './components/download5'
import SvgIcon from '@/components/SvgIcon'
import templateDownload from './components/template-download'
import OnJob from './components/on-job'

const maps = new Map([
  [1, { key: '1057', icon: 'download-c', state: 1 }],
  [2, { key: '1058', icon: 'tax', state: 2 }],
  [6, { key: '1481', icon: 'staff-info', state: 6 }],
  [8, { key: 'pnd3', icon: 'staff-info', state: 8 }],
  [5, { key: '1590', icon: 'staff-info', state: 5 }],
  [7, { key: '1860', icon: 'staff-info', state: 7 }],
  [4, { key: '1480', icon: 'staff-info', state: 4 }]
  // 暂时去掉
  // [3, { key: '1059', icon: 'staff-info', state: 3 }]
])

export default {
  components: { download, downloadTawi, SvgIcon, templateDownload, OnJob },
  data() {
    return {
      isViewTemplateSetting: false,
      status: true, // 详情展示
      type: false,
      proveDatas: maps
    }
  },
  computed: {
    ...mapState({
      theme: state => state.settings.themeColor
    }),
    sonTitle() {
      return this.$t(this.isViewTemplateSetting ? '1861' : maps.get(this.type)?.key || '')
    }
  },
  methods: {
    handlerCloseTem() {
      this.isViewTemplateSetting = false
      this.status = true
    },
    // 模版配置开启
    handleOpenTemplateSetting() {
      this.status = false
      this.isViewTemplateSetting = true
    },
    // type 证明类型
    // status 是否关闭详情
    open(type, status) {
      // 模版设置隐藏
      this.isViewTemplateSetting = false
      this.status = status || false
      type && (this.type = type)
    }
  }
}
</script>

<style lang="scss">
.wrap {
  .prove-header {
    display: flex;
    margin: 0.67em 0;
    .common-header {
      margin: 0;
      flex: 1;
    }
  }
  .prove-title {
    cursor: pointer;
    &:hover {
      opacity: 0.9;
    }
  }
  .by-content {
    .active-list {
      display: flex;
      flex-wrap: wrap;
      transition: width 0.3s;
      li {
        padding: 30px 20px;
        display: flex;
        align-items: center;
        border: 2px solid;
        margin-right: 20px;
        text-align: center;
        cursor: pointer;
        border-radius: 4px;
        user-select: none;
        margin-top: 25px;
        transition: all 1s;
        svg {
          font-size: 20px;
          transform: translateY(2px);
        }
        &:hover {
          box-shadow: 0 0 8px #ccc;
        }
        &:active {
          box-shadow: 0 0 8px rgb(117, 116, 116);
        }
      }
    }
  }
}
</style>
>
